'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { InputComponent as Input } from '@/components/input/main'
import { useAuth, useLoader } from '@/hooks'
import { supabaseAuth } from '@/services/supabase'
import type { FormLogin } from '@/types/form'
import { notice } from '@/utils/addon'

export function FormSignInComponent() {
  // __STATE's
  const router = useRouter()
  const loader = useLoader()
  const auth = useAuth()

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormLogin>({
    defaultValues: {
      keepLoggedIn: true
    }
  })

  // __FUNCTION's
  const onSubmit = handleSubmit(async (formData) => {
    loader.on()

    const { error } = await supabaseAuth.signInWithPassword({
      email: formData.email,
      password: formData.password
    })

    if (error) loader.off()
  })

  // __EFFECT's
  useEffect(() => {
    if (auth.isAuth()) {
      notice.success('Admin logged-in ✅', { title: 'Success', duration: 1 })
      router.push('/lobby')
      loader.off()
    }
  }, [auth])

  // __RENDER
  return (
    <form className='w-80' onSubmit={onSubmit}>
      <div className='grid gap-4'>
        <Input
          key='.email'
          type='email'
          icon='person'
          name='email'
          label='Email Address'
          register={register}
          errors={errors.email}
          rules={{ required: true }}
        />

        <Input
          key='.password'
          type='password'
          icon='lock'
          name='password'
          label='Password'
          register={register}
          errors={errors.password}
          rules={{ required: true }}
        />
      </div>

      <div className='mt-6 flex flex-col'>
        <button className='btn btn-primary h-12' type='submit'>
          <span className='text-base font-bold capitalize'>sign-in</span>
        </button>
      </div>
    </form>
  )
}
